import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AnimationHelper } from 'src/app/helpers/animation.helper';
import { IFile } from 'src/app/interfaces/io/file.interface';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ShellService } from 'src/app/services/process/shell.service';
import { IconsService } from 'src/app/services/ux/icons.service';
import { ThemeService } from 'src/app/services/ux/theme.service';

@Component({
  selector: 'app-launcher',
  templateUrl: './launcher.component.html',
  styleUrls: ['./launcher.component.scss']
})
export class LauncherComponent implements OnInit {
  @ViewChild("label") label: ElementRef;

  @Input() name: string;
  @Input() icon: string;
  @Input() selected = false;
  @Input() authenticationRequired = false;

  private iconUrl;

  authIcon: string = null;
  authSuccessIcon: string = null;

  constructor(
    public theme: ThemeService,
    private authSv: AuthService,
    private shell: ShellService,
    private iconSv: IconsService) {
  }

  ngOnInit() {
    this.iconUrl = this.iconSv.getIcon(this.icon);

    if (this.authenticationRequired) {
      this.authIcon = this.iconSv.getIcon("security-shield");
      this.authSuccessIcon = this.iconSv.getIcon("security-shield-success");
    }
  }

  get isAuthenticated() {
    return this.authSv.isLogged;
  }

  get iconBackgroundStyle() {
    let style = this.theme.mainToolbarStyle;

    if (this.iconUrl && this.iconUrl !== "") {
      style += `background-image: url(${this.iconUrl});`;
    }

    return style;
  }

  launch(file: IFile, cwd?: string) {
    this.animateLaunch();
    this.shell.launch(file, cwd);
  }

  private animateLaunch() {
    //  @todo Load animation from a configuration
    AnimationHelper.animate(this.label.nativeElement, "bounce");
  }
}
